import React, { useEffect, useRef } from 'react';
import './TeamFeatures.css';

const TeamFeatures = () => {
  const benefitsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    benefitsRef.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const benefits = [
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M24 4L32 12H40V36H8V12H16L24 4Z" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      ),
      title: 'Collaborate Across Multiple Stalls',
      description: 'Team members can work from different locations while keeping data synchronized'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M16 24L20 28L32 16" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Managers Track Performance Centrally',
      description: 'Get insights into team performance and lead collection across all stalls'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="12" r="8" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M8 44V36C8 32 12 28 24 28C36 28 40 32 40 36V44" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Seamless Teamwork & Lead Sync',
      description: 'Real-time synchronization ensures no lead is ever lost or duplicated'
    }
  ];

  return (
    <section className="team-features">
      <div className="container">
        <div className="team-content">
          <h2>Sync Leads Securely Across Your Team</h2>
          <p>Perfect for teams at exhibitions, trade shows, and events</p>
          
          <div className="team-benefits">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                ref={(el) => (benefitsRef.current[index] = el)}
                className="benefit-card"
              >
                <div className="benefit-icon">
                  {benefit.icon}
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamFeatures;